import ReusableDataTable from "src/components/table/ReusableDataTable";
import { mapProvinceToDataTable as mapData } from "./Helper";
import GetProvinceColumns from "./ColumnDefinition/ProvinceColumn/GetProvinceColumns";

const ProvinceTable = ({
  data,
  handleDelete,
  handleOpenPopup,
  status,
  provinceId,
}) => {
  const columns = GetProvinceColumns({
    handleDelete,
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable
      columns={columns}
      data={mapData(data, provinceId)}
      maxHeight={450}
    />
  );
};

export default ProvinceTable;
